<template>
    <v-content>
      <v-container>
        <v-layout >
          <v-flex>
            <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
            <v-card>
              <v-card >
                <v-toolbar :color="this.getTheme.color" dark>
                  <v-toolbar-title>Selecionar Agenda</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-list two-line>
                  <div :key="index" v-for="(item, index) in auth.customers">
                    <v-list-tile
                      avatar
                      ripple
                      @click="toggle(index, item.myClinic)"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>Clinica/Hosp.: {{ item.myClinic.customerName }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">Nome: {{ item.myClinic.name }}</v-list-tile-sub-title>
                        <v-list-tile-sub-title><span>CRM/ID:</span> {{ item.myClinic.crm }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <!-- <v-list-tile-action-text><v-checkbox v-model="item.myClinic.action" @click="toggle"></v-checkbox></v-list-tile-action-text> -->
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider
                      v-if="index + 1 < auth.customers.length"
                      :key="index"
                    ></v-divider>
                  </div>
                </v-list>
              </v-card>

              <v-card-actions>
                <!-- <router-link to="/schedule">
                  <v-btn flat color="orange" >Cancelar</v-btn>
                </router-link> -->
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import localforage from 'localforage'
  export default {
    computed: {
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('app', ['getTheme', 'getDevice']),
      ...mapGetters('auth', ['getRegisterUser', 'getSearchUser'])
    },
    data () {
      return {
        newRegisters: [],
        items: [],
        valid: false,
        loadingOk: false,
        loadingButton: false,
        loader: null,
        e1: true,
        p1: true,
        custom: true,
        username: null,
        checkbox: false,
        item: {
          action: false
        }
      }
    },
    mounted () {
    },
    methods: {
      ...mapActions('auth', ['setChangeSchedule']),
      toggle (index, item) {
        localforage.setItem('my-clinic-crm', item.crm, (err, data) => {
          console.log(data, 'change agenda')
          if (err) window.console.error(err)
          this.setChangeSchedule(item).then(() => this.$bus.$emit('setDialogSelectCRM', false))
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/schedule/change.vue